import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/apiClient'
import type { components } from '../lib/api-types'

export type ElementDetail = components['schemas']['ElementDetail']

/** Element detail (structure + operational status + instances) for the panel. */
export function useElementDetail(key: string | null) {
  return useQuery({
    queryKey: ['element', key],
    enabled: key !== null,
    queryFn: async (): Promise<ElementDetail> => {
      const { data, error } = await api.GET('/v1/elements', {
        params: { query: { key: key as string } },
      })
      if (error || !data) throw new Error('Failed to load element')
      return data
    },
  })
}
